"use client";

import { COOKIES } from ".constants/cookies";
import { Box, Text } from "@cloai/uikit";
import { map } from "lodash";
import { useTranslations } from "next-intl";
import { FC, memo } from "react";
import { useCookies } from "react-cookie";

import { useTimer } from "@/components/hooks/useTimer";
import {
  useProfileContext,
  usePaymentContext,
  useABtestContext,
} from "@/providers";

import { BuyItemWide } from "./BuyItemWide";

export const PacksList: FC = memo(() => {
  const t = useTranslations("BuyPage");
  const n = useTranslations("TimerForOffer");
  const profile = useProfileContext();
  const { userPacksList, dealerPacksList, userPromoPacks } =
    usePaymentContext();
  const { AB_notification_balance } = useABtestContext();
  const [cookies] = useCookies([COOKIES.PROMO_PACK_ENDTIME]);
  const promoTime = useTimer(cookies.promoPackEndtime);

  const promoPack = userPromoPacks[0];

  // TODO: убрать AB тест после окончания
  const isShowPromoPacks =
    AB_notification_balance && cookies.promoPackEndtime && promoPack;

  return (
    <>
      <Box gap={4}>
        {profile?.isDealer && <Text text={t("usersPacks")} color="violet" />}
        {map(userPacksList, (coinPack, index) => (
          <BuyItemWide key={index} index={index} coinPack={coinPack} />
        ))}
      </Box>

      {isShowPromoPacks && (
        <div className="flex flex-col gap-3">
          <div className="flex flex-wrap items-center justify-center gap-x-3">
            <Text
              text={t("promoPackTitle")}
              color="orange"
              className="text-center"
            />
            {promoTime && (
              <div className="flex items-center justify-center gap-1">
                {`${promoTime.formattedHours}${n("hours")} : `}
                {promoTime.formattedMinutes}
                {n("minutes")} : {promoTime.formattedSeconds}
                {n("seconds")}
              </div>
            )}
          </div>

          <BuyItemWide key={5} index={4} coinPack={promoPack} />
        </div>
      )}

      {profile?.isDealer && (
        <Box gap={4}>
          <Text text={t("dealerPacks")} color="orange" />
          {map(dealerPacksList, (coinPack, index) => (
            <BuyItemWide key={index} index={index} coinPack={coinPack} />
          ))}
        </Box>
      )}
    </>
  );
});
PacksList.displayName = "PacksList";
